export default __webpack_public_path__ + "static/media/laptop1.5f0322ec.jpg";